import WatchV2 from './Watch.v2'

export default WatchV2
// eslint-disable-next-line import/export
export * from './Watch.v2'
